import _slicedToArray from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _get from "lodash/get";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import defaultEntry from './default.vue';
import customizedEntry from './customized.vue';
import { doLangFunction } from '@/hooks/lang';
import { $setLang } from '@/assets/common/common.js';
import { VueCookieNext } from 'vue-cookie-next';
import { useRoute, useRouter } from 'vue-router';
import { SOFTWAREFLAG } from '@/utils/config';
export default {
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var lang = ref(VueCookieNext.getCookie('lang'));
    if (route.query.lang) {
      var qlang = doLangFunction(route.query.lang);
      if (qlang !== lang.value) {
        $setLang(qlang);
      }
    }
    var componentName = shallowRef(defaultEntry);
    var sn = route.query.sn || '';
    if (route.params.device) {
      componentName.value = customizedEntry;
      sessionStorage.setItem(SOFTWAREFLAG, route.params.device.toUpperCase() + '_mobile_' + sn);
    } else if (route.query.login_type) {
      sessionStorage.setItem(SOFTWAREFLAG, route.query.login_type.toUpperCase() + '_desktop_' + sn);
    } else if (sessionStorage.getItem(SOFTWAREFLAG)) {
      var _sessionStorage$getIt = sessionStorage.getItem(SOFTWAREFLAG).split('_'),
        _sessionStorage$getIt2 = _slicedToArray(_sessionStorage$getIt, 2),
        soft = _sessionStorage$getIt2[0],
        device = _sessionStorage$getIt2[1];
      if (device === 'mobile') {
        router.replace({
          name: route.name,
          params: {
            device: soft
          }
        });
        componentName.value = customizedEntry;
      }
    }
    var isQtstyleList = _get(window, 'app.global.isQtstyleList', ['modelCode']);
    if (Array.isArray(isQtstyleList) && isQtstyleList.length) {
      isQtstyleList.forEach(function (v) {
        if (route.query[v]) {
          sessionStorage.setItem('ISQTSTYLE_TYPE', '1');
        }
      });
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(_resolveDynamicComponent(_unref(componentName)));
    };
  }
};